import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { initStore } from "./store";
import { BrowserRouter, Redirect, Route, Switch  } from "react-router-dom";
import MainRoutes from "./Components";
import * as serviceWorker from "./serviceWorker";

import "antd/dist/antd.css";
import "./index.css";
import "./Components/App/App.css";
import "./i18n/config";
ReactDOM.render(
  <Provider store={initStore()}>
    <BrowserRouter>
      <Switch>
        <Route path="/" render={(props) => <MainRoutes {...props} />} />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
